import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { SortableContext, horizontalListSortingStrategy } from '@dnd-kit/sortable';
import DraggableCell from '../DraggableCell';

const TableBody = ({ table, tableVisibleColsKey }) => {
  const sortableItems = React.useMemo(() => table.getVisibleLeafColumns().map(c => c.id), [tableVisibleColsKey]);

  return (
    <tbody className="NewBaseTable__body">
      {table.getRowModel().rows.map(row => (
        <tr className="NewBaseTable__row" key={row.id}>
          <SortableContext items={sortableItems} strategy={horizontalListSortingStrategy}>
            {row.getVisibleCells().map(cell => (
              <DraggableCell key={cell.id} tableVisibleColsKey={tableVisibleColsKey} cell={cell} />
            ))}
          </SortableContext>
        </tr>
      ))}
    </tbody>
  );
};

TableBody.propTypes = {
  table: PropTypes.object.isRequired,
  tableVisibleColsKey: PropTypes.string.isRequired,
};

const MemoizedTableBody = memo(
  TableBody,
  (prev, next) =>
    prev.table.options.data === next.table.options.data && prev.tableVisibleColsKey === next.tableVisibleColsKey
);

export default MemoizedTableBody;
